import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http'; 
import { NotificationService } from '../../share/services/notification.service';
import { catchError, map, of, throwError } from 'rxjs';
import { AzureADUser } from '../models/azureaduser.model';
import { DatasetModel } from '../models/dataset-model.model';
import FetrapiEnums from '../enum/enums';
import { GridDataResult } from '../models/griddataresult.model';
import { Member } from '../models/member.model';
import { LogLogging } from '../models/log-logging-model';
import { ConfigService } from './config.service';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
}) 

export class ApiService {

  constructor(
    private Http: HttpClient,
    private notificationService: NotificationService,
    private configService: ConfigService,
    private sessionService: SessionService
  ) { }

  getMembers() {  
    return this.Http.get(`${this.configService.getEnv('fetrapiApi')}Members`).pipe(
      map((data) => { return data as Member[]; })
      , catchError(error => { return throwError('Something went wrong!'); })
    )
  } 

  getLogs() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }

    var body = '{"dateTimeFrom": "2000-05-20T19:24:59.123Z", "dateTimeTo": "2999-05-20T19:24:59.123Z", "logentryType": ["API", "Login", "Notification"] }';

    return this.Http.post(`${this.configService.getEnv('fetrapiApi')}FindLogdata`, body, httpOptions).pipe(
      map((data) => { return data as LogLogging[]; })
    )
  }

  getMember(memberId: string) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: new HttpParams().append('MemberId', memberId)
    }
    return this.Http.get(`${this.configService.getEnv('fetrapiApi')}GetMemberAD`, httpOptions)
      .pipe(
        map((data) => {
          return data as AzureADUser;
        }) 
    )
  }

  getDataSets(datasettypes: string, statuscodes: any, memberId?: string) { 
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    var body = ' { "filterCriteria": { "dateTimeFrom": "2020-05-20T19:24:59.123Z", "dateTimeTo": "2030-05-20T19:24:59.123Z"' + (memberId != null ? ', "memberId": "' + memberId + '"' : '') + ', "datasetTypes": [ ' + datasettypes + ' ]' + (statuscodes != null ? ', "statusCodes": [ ' + statuscodes + ' ]' : '') + ' } }';
    return this.Http.post(`${this.configService.getEnv('fetrapiApi')}FindDatasets`, body, httpOptions).pipe(
      map((data) => data as DatasetModel[]),
      catchError(error => {console.log(error); return throwError(() => new Error('Something went wrong!')); })
    )
  }

  requestConfirmation() {    
    return this.Http.post(`${this.configService.getEnv('fetrapiApi')}Datasets/RequestConfirmation`, null); 
  }

  startConsolidation(skipWarnings: boolean) {
    let url = skipWarnings ? `${this.configService.getEnv('fetrapiApi')}Datasets/Consolidate/all` : `${this.configService.getEnv('fetrapiApi')}Datasets/Consolidate`;
    return this.Http.post(url, null);
  }
  
  confirmDataset(datasetid: string, status: FetrapiEnums.DatasetStatusCode) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    var body = '"' + status + '"';
    this.Http.patch(`${this.configService.getEnv('fetrapiApi')}Datasets/` + datasetid, body, httpOptions).subscribe({
      next: (res: any) => { 
        console.log('received ok response from patch request');
      },
      error: (error: any) => {
        console.error('There was an error during the request: ' + error.error.message);
        console.log(error);
      }
    });
    console.log('request sent. Waiting for response...');
  }

  updateDatasetStatus(datasetid: string, status: FetrapiEnums.DatasetStatusCode) { 
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    var body = '"' + status + '"'; 
    return this.Http.patch(`${this.configService.getEnv('fetrapiApi')}Datasets/` + datasetid, body, httpOptions).pipe(
      map((data: any) => { return data as any; })
    ) 
  }

  GridData(file: File)
  { 
    console.log('entering api: GridData. Filename: ' + file.name); 
    
    let formData:FormData = new FormData();
    formData.append('File', file, file.name);

    return this.Http.post(`${this.configService.getEnv('fetrapiApi')}GridData`, formData).pipe(
      map((data) => { return data as GridDataResult; })
    ) 
  }

  ZoIData(file: File)
  { 
    console.log('entering api: ZoIData. Filename: ' + file.name); 
    
    let formData:FormData = new FormData();
    formData.append('File', file, file.name);

    return this.Http.post(`${this.configService.getEnv('fetrapiApi')}ZOI`, formData)
    .pipe(
      map((data) => { return data as GridDataResult; }) 
    ) 
  }

  //Retrieves all unread user's notifications 
  getNotifications() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }   

    const userLanguage = this.sessionService.getPreferredLanguage();
    const mainGroup_gId = this.sessionService.getMaingroup()?.gId ?? '';
    var body = '{"filterCriteria": {"dateTimeFrom": "2000-05-20T19:24:59.123Z", "dateTimeTo": "2999-05-20T19:24:59.123Z", "actorId": "' + mainGroup_gId + '","statusCodes": ["New"], "notificationTypes": ["RequestingApproval", "UploadGridDataError", "MemberApproved", "MemberRejected", "RequestAdminApproval", "AdminApproved", "AdminRejected", "FriendlyMessage", "NewADCRExtract", "NewChIIIExtract", "ConsolidationError", "ConfirmationExists", "ExtractsGenError", "ConfirmationRequired", "ConfirmedDataset", "FetrapiConsolidate", "IntGridDataExtract", "KLIMExtract"]}, "includeMessages": true, "language": "' + userLanguage + '" }';
     
    return this.Http.post(`${this.configService.getEnv('fetrapiApi')}FindNotifications`, body, httpOptions)
    .pipe(
      map((data) => { return data as Notification[]; }) 
    )
  }

  readNotification(notificationId: string) {  
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    var body = '{ "readConfirmation": [ "' + notificationId + '" ] }';

    return this.Http.patch(`${this.configService.getEnv('fetrapiApi')}Notifications`, body, httpOptions)
      .pipe(
        map(() => { return true; }),
        catchError((error) => { return of(null); })
      )

  }

  getValidationReport(datasetId: string) { 
    return this.Http.get(`${this.configService.getEnv('fetrapiApi')}ValidationReport/` + datasetId)
    .pipe(
      map((data) => { return data as any[]; }),
      catchError(error => { return throwError(() => new Error('Something went wrong!')) })
    ) 
  } 

  downloadDataset(datasetId: string) {
    return this.Http.get(`${this.configService.getEnv('fetrapiApi')}Dataset/` + datasetId)
    .pipe(
      map((data) => { return data as any[]; }) 
    )   
 
  }

  getPortalVersion() {
    return this.Http.get(`${this.configService.getEnv('fetrapiApi')}PortalSettings/`)
    .pipe(
      map((data) => { return data as any[]; })
    )
  }

  hasValidationReport(datasetId: string) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }

    const userLanguage = this.sessionService.getPreferredLanguage();
    const mainGroup_gId = this.sessionService.getMaingroup()?.gId ?? '';
    var body = '{"filterCriteria": {"dateTimeFrom": "2000-05-20T19:24:59.123Z", "dateTimeTo": "2999-05-20T19:24:59.123Z", "datasetId": "' + datasetId + '", "actorId": "' + mainGroup_gId + '","statusCodes": ["New"], "notificationTypes": ["ValidationReport"]}, "includeMessages": true, "language": "' + userLanguage + '" }';

    return this.Http.post(`${this.configService.getEnv('fetrapiApi')}FindNotifications`, body, httpOptions).pipe(
      map((data) => { return (data as Notification[]).length > 0; })
    )
  }

  public errorhandler(error: any) {
    switch (error.status) {
      case 401:
      case 500:
      //case 404:
        this.notificationService.showFetrapiMessage(error.status + ': ' + error.message);
        break;
    } 
    // console.error(error);
  }

}
